<template>
  <div class="block-site-recommand">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h2>热门节点</h2>
          <div class="content">
            <div class="block-site-two has-theme" style="background-size: cover;background-color: rgb(111, 169, 228); background-image: url(http://image.iphpt.com/g9zz_node_bg5.jpg);">
              <div class="musk"></div>
              <a href="#">
                <div class="ctt">
                  <div class="name">全部分类</div>
                </div>
              </a>
            </div>
            <div class="block-site-two has-theme" style="background-size: cover;background-color: rgb(111, 169, 228); background-image: url(http://image.iphpt.com/g9zz_node_bg6.jpg);">
              <div class="musk"></div>
              <a href="#">
                <div class="ctt">
                  <div class="name">全部分类</div>
                </div>
              </a>
            </div>
            <div class="block-site-two has-theme" style="background-size: cover;background-color: rgb(111, 169, 228); background-image: url(http://image.iphpt.com/g9zz_node_bg7.jpg);">
              <div class="musk"></div>
              <a href="#">
                <div class="ctt">
                  <div class="name">全部分类</div>
                </div>
              </a>
            </div>
            <div class="block-site-two has-theme" style="background-size: cover;background-color: rgb(111, 169, 228); background-image: url(http://image.iphpt.com/g9zz_node_bg8.jpg);">
              <div class="musk"></div>
              <a href="#">
                <div class="ctt">
                  <div class="name">全部分类</div>
                </div>
              </a>
            </div>
            <div class="block-site-two has-theme" style="background-size: cover;background-color: rgb(111, 169, 228); background-image: url(http://image.iphpt.com/g9zz_node_bg10.jpg);">
              <div class="musk"></div>
              <a href="#">
                <div class="ctt">
                  <div class="name">全部分类</div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    data() {
      return {
      }
    }
  }
</script>

<style>
  .block-site-recommand{
    background-image: url(http://image.iphpt.com/g9zz_node_bg2.jpg);
    /*background-size: cover;*/
    background-repeat:no-repeat;
    /*background-size:100% 100%;*/
    -moz-background-size:100% 100%;
    /*min-height: 500px;*/
  }
  .block-site-recommand .container{
    padding-top: 150px;
  }
</style>



// WEBPACK FOOTER //
// src/components/HeaderNode.vue